var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16536 17.833H7.08036L15.9954 8.91802L15.0804 8.00302L6.16536 16.918V17.833ZM5.33203 18.6664V16.5664L16.3154 5.57302C16.4015 5.49691 16.4959 5.43802 16.5987 5.39635C16.7015 5.35469 16.809 5.33358 16.9212 5.33302C17.0334 5.33246 17.1418 5.35024 17.2462 5.38635C17.3518 5.42135 17.449 5.48469 17.5379 5.57635L18.427 6.47135C18.5187 6.55969 18.5815 6.65691 18.6154 6.76302C18.6487 6.86858 18.6654 6.97413 18.6654 7.07969C18.6654 7.19302 18.6465 7.30135 18.6087 7.40469C18.5704 7.50747 18.5098 7.60163 18.427 7.68719L7.4312 18.6664H5.33203ZM15.5304 8.46802L15.0804 8.00302L15.9954 8.91802L15.5304 8.46802Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.cccd53ad4b8b3b1733902f9b788908aa.svg";
export { ForwardRef as ReactComponent };